import { httpRequest } from '@calendly/http-tools'
import { createAsyncThunk } from '@reduxjs/toolkit'

export const fetchCurrentSubscription = createAsyncThunk(
  'currentSubscription/fetchSubscription',
  async (_, { rejectWithValue }) => {
    const [success, response] = await httpRequest({
      url: '/api/billing/subscription',
      method: 'GET'
    })

    if (!success) {
      return rejectWithValue(response)
    }

    return response
  }
)
